import { type AnyAction } from 'redux';
import { RESOLVE_PROMISIFIED_ACTION } from './promisified-actions-actions';

export function promisifiedActionsResults(state: Record<string, any> = {}, action: AnyAction) {
  switch (action.type) {
    case RESOLVE_PROMISIFIED_ACTION:
      const { payload, isResolved, correlationId } = action.payload;
      return {
        ...state,
        [correlationId]: {
          payload,
          isResolved,
        },
      };

    default:
      return state;
  }
}
